import { OPEN_SERVICES_CONSTANTS } from "./constants";
import { Text } from "@chakra-ui/react";
import { Balancer } from "react-wrap-balancer";
import { useTextVariants } from "@/theme/components/useSectionHeading";

const ServicesComponent = () => {
  const TextVariant = useTextVariants();
  return (
    <Balancer>
      <Text
        px={6}
        variant={TextVariant}
        color="text.100"
        textAlign={"center"}
        lineHeight={"30px"}
      >
        {OPEN_SERVICES_CONSTANTS.text}
      </Text>
    </Balancer>
  );
};

export default ServicesComponent;
